import { ApolloLink } from '@apollo/client';
import { useMemo } from 'react';

import { useTMContext } from '#src/contexts/tm/index.ts';

type Props = {
  path: string;
};

const GRAPHQL_INT_MAX = Math.pow(2, 31) - 1; // max 32-bit integer value

export const useTMLink = ({ path }: Props) => {
  const logOperation = useTMContext()?.logOperation;

  const tmLink = useMemo(() => {
    if (!logOperation) {
      return undefined;
    }

    return new ApolloLink((operation, forward) => {
      const start = Date.now();

      return forward(operation).map(response => {
        const context = operation.getContext();

        if (!context.response) {
          // this is a websocket response, no HTTP response provided
          return response;
        }

        const { operationName } = operation;
        const timeMs = Math.min(Date.now() - start, GRAPHQL_INT_MAX);

        // Do not log ReportTelemetry to avoid requests when the client is idle
        if (operationName !== 'ReportTelemetry') {
          logOperation({ name: operationName, timeMs, path });
        }

        return response;
      });
    });
  }, [logOperation, path]);

  return tmLink;
};
